import React from 'react';

import GradeHero from 'Components/GradeHero';
import HeroSplitPanes from 'Components/HeroSplitPanes';

const isPropEmpty = prop => {
  return typeof prop === 'undefined' || prop === null || prop.length === 0;
};

const Hero = props => {
  if (props.sponsored) {
    // We only want to show the Tinybop Schools promo if the user is
    // 1) on a desktop machine,
    // 2) with a window size greater than 962px,
    // 3) and using a browser/computer that supports WebGL.
    // https://developer.mozilla.org/en-US/docs/Learn/WebGL/By_example/Detect_WebGL
    if (props.hero.id === 'TinybopSchools201809') {
      const supportsWebGL = () => {
        // Create canvas element. The canvas is not added to the
        // document itself, so it is never displayed in the
        // browser window.

        const canvas = document.createElement('canvas');
        // Get WebGLRenderingContext from canvas element.
        const gl =
          canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

        return gl && gl instanceof WebGLRenderingContext;
      };
      if (
        window.innerWidth < 962 ||
        typeof window.orientation !== 'undefined' ||
        !supportsWebGL
      ) {
        return null;
      }
    }

    return (
      <HeroSplitPanes
        {...props.hero}
        onAdClick={props.onAdClick}
        onAdLoad={props.onAdLoad}
        sponsored
      />
    );
  }

  if (props.hero) {
    const { hero, heroType } = props;
    const item = hero && hero.items[0];
    const { slug, type, series } = item || {};
    const seriesText = series ? `/${series}` : '';
    const url =
      type === 'series' ? `/videos/${slug}` : `/${type}s${seriesText}/${slug}`;

    const heroProps = {
      title: isPropEmpty(hero.title) ? item && item.title : hero.title,
      dek: isPropEmpty(hero.dek) ? item && item.briefDescription : hero.dek,
      link:
        isPropEmpty(hero.link) && !(hero && hero.externalLink)
          ? url
          : hero.link,
      imageURI: isPropEmpty(hero.imageURI)
        ? item && item.imageURI
        : hero.imageURI,
      mediaType: type,
      buttonLabel: hero && hero.buttonLabel,
      id: hero && hero.id,
      externalLink: hero && hero.externalLink,
      buttons: hero && hero.buttons,
    };

    if (heroType === 'grade') {
      return <GradeHero {...heroProps} />;
    }
    return <HeroSplitPanes {...heroProps} />;
  }
  return null;
};

export default Hero;
